export default __webpack_public_path__ + "static/media/nice.0f39e089.jpg";